import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/dasboard/DashboardLayout";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { FileKeysProvider } from "./context/fileKeysContext";
import { ProfessionsAndSkillsProvider } from "./context/professionsAndSkillsContext";
import { ExpertArticlesProvider } from "./context/expertArticlesContext";
import { ExpertVideosProvider } from "./context/expertVideosContext";
import { ExpertDataProvider } from "./context/expertDataContext";
import { ExpertProfessionsProvider } from "./context/expertProffessionsContext";
import { ExpertExpertisesProvider } from "./context/expertExpertisesContext";
import "../src/globals.css";
import "react-toastify/dist/ReactToastify.css";
import { FarmerFilterProvider } from "./context/farmerFilterContext";
import { UploadingProcessProvider } from "./context/uploadingProcessContext";
import { AcProvider } from "./context/activityConsultingContext";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryComponent from "./components/error/ErrorBoundaryComponent";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 55 * (60 * 1000),
      cacheTime: 60 * (60 * 1000),
      retry: 3,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastContainer closeOnClick />
      <ErrorBoundary fallback={<ErrorBoundaryComponent/>}>

      <ExpertDataProvider >
        <ExpertProfessionsProvider>
          <ExpertExpertisesProvider>
            <FileKeysProvider>
              <UploadingProcessProvider>
                <ProfessionsAndSkillsProvider>
                  <ExpertArticlesProvider>
                    <ExpertVideosProvider>
                      <FarmerFilterProvider>
                        <AcProvider>
                          
                        <main>
                          <Routes>
                            <Route path="login" element={<LoginPage />} />
                            <Route
                              path="/*"
                              element={<DashboardLayout />}
                              index
                            />
                          </Routes>
                        </main>
                        </AcProvider>
                      </FarmerFilterProvider>
                    </ExpertVideosProvider>
                  </ExpertArticlesProvider>
                </ProfessionsAndSkillsProvider>
              </UploadingProcessProvider>
            </FileKeysProvider>
          </ExpertExpertisesProvider>
        </ExpertProfessionsProvider>
      </ExpertDataProvider>
      </ErrorBoundary>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}

export default App;
